module.exports = __webpack_public_path__ + "static/media/link.def34b50.svg";